import { EXPERIMENT_VARIATION } from 'shared/experiments/consts/variants'
import { type Experiment } from 'types/shopConfig'

export const DEFAULT_EXPERIMENT: Partial<Experiment> = {
  variant: EXPERIMENT_VARIATION.DEFAULT,
  isEnabled: false,
  active: false,
  variables: {},
}
